import { render, staticRenderFns } from "./MarketingManagement.vue?vue&type=template&id=ec2ba37e&scoped=true&"
import script from "./MarketingManagement.vue?vue&type=script&lang=js&"
export * from "./MarketingManagement.vue?vue&type=script&lang=js&"
import style0 from "./MarketingManagement.vue?vue&type=style&index=0&id=ec2ba37e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2ba37e",
  null
  
)

export default component.exports